import { Module } from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import { State } from '@/main/store'
import { MentorInitialState } from './types'

const mentorStore: Module<MentorInitialState, State> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default mentorStore
